import ControlToggleView from "components/shared/views/BaseToggleView/components/ControlToggleView";
import React, { useState } from "react";
import { SVGAsset } from "res";

/**
 * @function PauseCardControlRow
 * @return {React.Component}
 * @exported true
 * @description The main component for PauseCardControlsTemporarilyPage
 */

export default function PauseCardControlRow(props) {
    const nonExpanded = props.subText ?? "";
    const expanded = props.expandedText;

    const [state, setState] = useState(false);
    const toggle = evt => setState(!state);

    const icon = expanded === undefined
        ? <SVGAsset id="RightChevronIcon" className="clickable chevron-icon" onClick={toggle} />
        : <SVGAsset id={state ? "DownChevronIcon" : "RightChevronIcon"} onClick={toggle} className="clickable chevron-icon" />

    const textToShow = state ? expanded : nonExpanded;

    return (
        <ControlToggleView
            {...props}
            subText={textToShow}
            icon={icon} />
    );
}
